export default __webpack_public_path__ + "static/Icon27001-b4372b0ba0cba502390ad45692aaaf3e.png";